import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import redactSensitiveUrls from './posthogRedaction';
import { POSTHOG_HOST, POSTHOG_KEY } from './consts';

if (POSTHOG_KEY && POSTHOG_HOST) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: '2026-01-30',
    capture_pageview: 'history_change',
    before_send: redactSensitiveUrls,
    // Neither is redacted yet: replay hides the URL in `$snapshot_data`, heatmaps key by it.
    // Set here rather than left to remote config, so flipping either takes a deploy.
    disable_session_recording: true,
    capture_heatmaps: false,
  });
}

ReactDOM.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>,
  document.getElementById('root'),
);
